import React from 'react';
import { View } from 'react-native';
import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const PickListTotalItems = ({ totalPickQuantity }) => {
	const styles = useThemedStyles(createStyles);
	// For pages like confirm stock levels where there is no pick list total
	if (totalPickQuantity === undefined) {
		return null;
	}
	// For safety, should never be true
	if (totalPickQuantity === null) {
		return null;
	}
	return (
		<View style={styles.container}>
			<Text style={styles.label}>
				Pick list total:
			</Text>
			<Text style={styles.value}>
				{totalPickQuantity}
			</Text>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		backgroundColor: colors.card,
		paddingVertical: space.md,
		width: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		gap: space.sm,
	},
	label: {
		...type.rowText,
		color: colors.textSecondary,
	},
	value: {
		...type.cardTitle,
		color: colors.text,
	},
});

export default React.memo(PickListTotalItems);
